// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2AgBz","calendarButtons":"ClockData_calendarButtons__3y5Z7"};